module.exports = __webpack_public_path__ + "img/dialog.91f17ce2.png";